const Menu = [
  { is_header: true, title: "CMMS" },
  {
    path: "/setup-center",
    icon: "bi bi-rocket-takeoff",
    title: "Setup Center",
    permissions: ["view setup center"],
  },
  {
    path: "/work-order/list",
    icon: "bi bi-people",
    title: "Work Order",
    permissions: ["view work order"],
  },

  {
    path: "/request/list",
    icon: "bi bi-inbox",
    title: "Request",
    permissions: ["view request"],
    children: [
      { path: "/request/list", title: "Request List" },
      {
        path: "/request/public-link",
        title: "Request Universal Link Management",
      },
    ],
  },

  {
    path: "/analytics",
    icon: "bi bi-bar-chart",
    title: "Analytics",
    permissions: ["view analytic"],
  },
  {
    path: "/assets/list",
    icon: "bi bi-boxes",
    title: "Assets Management",
    permissions: ["view asset"],
  },
  {
    path: "/meter/list",
    icon: "bi bi-speedometer2",
    title: "Meters",
    permissions: ["view meter reading"],
  },
  {
    path: "/issue-tracking/list",
    icon: "bi bi-exclamation-circle",
    title: "Issue Tracking",
    permissions: ["view issue tracking"],
  },

  // {
  //   path: "/documents",
  //   icon: "bi bi-file-pdf",
  //   title: "Documents",
  //   children: [
  //     { path: "/document/list", title: "Documents" },
  //     { path: "/document/doc-chat", title: "Chat AI" },
  //   ],
  // },
  {
    path: "/purchase-order/list",
    icon: "bi bi-file-check",
    title: "Purchase Order & Quotation",
    permissions: ["view purchase order", "view quotation"],
    children: [
      {
        path: "/purchase-order/list",
        title: "Purchase Order",
        permissions: ["view purchase order"],
      },
      {
        path: "/quotation/list",
        title: "Quotation",
        permissions: ["view quotation"],
      },
    ],
  },
  {
    path: "/parts",
    icon: "bi bi-gear",
    title: "Parts & Inventory",
    permissions: ["view part", "view inventory"],
    children: [
      { path: "/part/list", title: "Parts", permissions: ["view part"] },
      {
        path: "/part/inventory",
        title: "Inventory",
        permissions: ["view inventory"],
      },
    ],
  },

  {
    path: "/report-generator",
    icon: "bi bi-file-pdf",
    title: "Reports",
    permissions: ["create report"],
    children: [
      {
        path: "/report-generator",
        title: "Report Generator",
        permissions: ["create report"],
      },
    ],
  },
  {
    path: "/vendors",
    icon: "bi bi-buildings",
    title: "Vendor & Customer",
    permissions: ["view vendor", "view customer"],
    children: [
      {
        path: "/vendor/management",
        title: "Vendor Management",
        permissions: ["view vendor"],
      },
      {
        path: "/customer/management",
        title: "Customer Management",
        permissions: ["view customer"],
      },
    ],
  },
  {
    path: "/workers",
    icon: "bi bi-person",
    title: "People & Team",
    permissions: ["view people", "view team"],
    children: [
      {
        path: "/workers/people",
        title: "Workers / People",
        permissions: ["view people"],
      },
      { path: "/workers/teams", title: "Team", permissions: ["view team"] },
    ],
  },
  {
    path: "/setup",
    icon: "bi bi-gear",
    title: "Setup",
    children: [
      {
        path: "/setup/company",
        title: "Company Profile",
        permissions: ["view company profile"],
      },
      {
        path: "/setup/location",
        title: "Location",
        permissions: ["view location"],
      },
      {
        path: "/setup/service-group",
        title: "Service Group",
        permissions: ["view service group"],
      },
      { path: "/setup/roles", title: "Roles", permissions: ["view role"] },
      {
        path: "/checklist/list",
        title: "Tasks & Checklist Generation",
        permissions: ["view checklist"],
      },
      {
        path: "/service/list",
        title: "Service",
        permissions: ["view service"],
      },
      {
        path: "/setup/category",
        title: "Category / Type",
        permissions: ["view category"],
      },
      {
        path: "/setup/whatsapp-gateway",
        title: "Whatsapp Gateway",
        permissions: ["view whatsapp"],
      },
      { path: "/import", title: "Import Data", permissions: ["view import"] },
      // { path: "/qrcode", title: "Print QR Code" },
    ],
  },
  // { path: '/helper', icon: 'bi bi-gem',	title: 'Helper' }
];

export default Menu;
